import { PaymentQueryParams } from '@tsin-core/models/payment.model';

const ACTION_SCOPE = '[Payment]';

export class GetPayments {
  static readonly type = `${ACTION_SCOPE} Get Payments`;
  constructor(public payload: PaymentQueryParams = {}) { }
}

export class SetPaymentLoading {
  static readonly type = `${ACTION_SCOPE} Set Loading`;
  constructor(public loading: boolean) { }
}

export class SetPaymentError {
  static readonly type = `${ACTION_SCOPE} Set Error`;
  constructor(public error: string | null) { }
}
